var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftBar"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Search UI Catalog")]),_c('div',{attrs:{"id":"version"}},[_vm._v("1.1.0")]),_c('div',{staticClass:"catalogComponent"},[_c('ul',_vm._l((_vm.sidebarRoutes),function(widget,index){return _c('div',{key:index,on:{"click":function($event){_vm.selectStyle (widget)}}},[_c('li',{staticClass:"clickable",class:{
            'active': widget.name===_vm.selectedItem,
            'main': widget.attribute==='main',
            'sub': widget.attribute!=='main'
          }},[_c('span',[_vm._v(_vm._s(widget.label || widget.name))])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }